<template>
    <div
        class="day"
        :class="dayClasses"
        @click="handleClick"
        @mouseenter="$emit('mouseenter')"
        @mouseleave="$emit('mouseleave')"
        v-tippy="{ content: tooltipContent, trigger: (tooltipContent && (mayInteract || (mode === 'check-out' && !day.check_out_blocked))) ? 'mouseenter' : 'manual' }"
    >
<!--        @click.right="showDebug"-->
        <div class="shading" />
        <div class="day-number-wrapper">
            <div
                class="may-click"
                v-if="mayInteract || (mode === 'check-out' && !day.check_out_blocked)"
            />

            <div
                class="day-number"
                v-text="Number(day.date.substring(8, 10))"
            />
<!--
            <div>
                <span v-text="day.min_days" />
                <span v-text="day.may_check_in ? 'i' : '-'" />
                <span v-text="day.may_check_out ? 'o' : '-'" />
                <span v-text="day.is_blocked ? 'b' : '-'" />
                <span v-text="day.fits_a_block ? 'f' : '-'" />
            </div>
-->
        </div>
        <div
            class="rate"
            v-html="rateLabel"
        />

<!--
        <div style="font-size: 9pt;">
            {{ day.fits_a_block ? 'fab' : '-&#45;&#45;' }}
            {{ !(this.day.is_check_in || this.day.is_blocked) ? '!ici' : '-&#45;&#45;' }}
            {{ !(this.tomorrow && !this.tomorrow.open) ? '!tom' : '-&#45;&#45;' }}
        </div>
        <div style="font-size: 9pt;">
            {{ day.may_check_in ? 'mci' : '-&#45;&#45;' }}
            {{ !day.check_out_blocked ? 'mco' : '-&#45;&#45;' }}
        </div>
        <div style="font-size: 9pt;">
            {{ mode }}
        </div>
-->
    </div>
</template>

<script>
import dayjs from 'dayjs';
import Vue from 'vue';
import VueTippy, { TippyComponent } from 'vue-tippy';
// import { getDiscount } from '../_modules/discounts';

Vue.use(VueTippy, {
    arrow: true,
    placement: 'top-start',
});
Vue.component('tippy', TippyComponent);

export default {
    props: {
        day: {
            type: Object,
            required: true,
        },
        yesterday: {
            type: Object,
        },
        tomorrow: {
            type: Object,
        },
        mode: {
            type: String,
            default: 'check-in',
        },
        dateIn: {
            type: String,
            default: null,
        },
        dateOut: {
            type: String,
            default: null,
        },
        hoverDay: {
            type: Object,
            default: null,
        },
    },

    computed: {
        isSelected() {
            if (this.dateIn && this.dateOut) {
                return dayjs(this.day.date).isBetween(this.dateIn, this.dateOut, null, '[]');
            }
            if (this.dateIn && this.hoverDay) {
               //  if (this.day.date === '2024-04-02') {
               //      console.debug('day.date', this.day.date);
               //      console.debug('dateIn', this.dateIn);
               //      console.debug('hoverDay.date', this.hoverDay.date);
               //      console.debug('hoverDay.check_out_blocked', this.hoverDay.check_out_blocked);
               //      console.debug('==========================');
               // }
                if (this.hoverDay.check_out_blocked) {
                    return false;
                }
                return dayjs(this.day.date).isBetween(this.dateIn, this.hoverDay.date, null, '[]');
            }
            return false;
        },

        dayClasses() {
            return {
                closed: !this.day.open,
                // newer
                start: this.day.is_check_in || (this.tomorrow && !this.tomorrow.open),
                end: this.day.is_check_out || (this.yesterday && !this.yesterday.open),
                middle: this.day.is_blocked || !this.day.fits_a_block,
                'may-check-in': this.mayInteract && this.day.may_check_in,
                //older
                // start: this.day.is_check_in,
                // end: this.day.is_check_out,
                // middle: this.day.is_blocked,
                // 'may-check-in': this.day.may_check_in && !(this.day.is_check_in || this.day.is_blocked),

                'may-check-out': !this.day.check_out_blocked,
                'selected-check-in': this.day.date === this.dateIn,
                'selected-check-out': this.day.date === this.dateOut,
                'selected': this.isSelected,
            }
        },

        tooltipContent() {
            if ( (this.mode === 'check-in' && this.day.may_check_in)
                || (this.mode === 'check-out' && this.day.date === this.dateIn) ) {
                return this.day.min_days ? `Minimum ${this.day.min_days} nights` : null;
            }
            return null;
        },

        rateLabel() {
            return (!this.mayInteract || isNaN(this.day.rate)) ? '&nbsp;' : `$${this.day.rate}`;
        },

        mayInteract() {
            return this.day.fits_a_block
                && !(this.day.is_check_in || this.day.is_blocked)
                && !(this.tomorrow && !this.tomorrow.open)
            ;
            // return this.day.open
            //     && !(this.day.is_check_in || this.day.is_blocked)
            //     && !(this.tomorrow && !this.tomorrow.open)
            // ;
        },
    },

    watch: {
        // hoverDay() {
        //     console.debug('hoverDay', this.hoverDay.date, this.hoverDay.check_out_blocked);
        // },
    },

    methods: {
        // getDiscount,

        handleClick() {
            // console.debug('handleClick', this.day.date);
            if (['check-in', 'selected'].includes(this.mode) && this.day.may_check_in) {
                this.$emit('check-in');
            } else if (this.mode === 'check-out' && !this.day.check_out_blocked) {
                this.$emit('check-out');
            }
        },

/*
        showDebug() {
            console.debug(JSON.parse(JSON.stringify(this.day)));
        },
*/
    },
};
</script>


<style lang="scss">
.day {
    border: 1px solid #ccc;
    //height: 2.5em;
    position: relative;
    font-size: 0.8em;
    text-align: center !important;
    line-height: 2.4;
    cursor: default;
    user-select: none;
    flex: 0 0 calc(100% / 7);

    .day-number-wrapper {
        overflow: visible;
        //border: 1px solid black;
        height: 2.5em;
        position: relative;
    }

    .day-number {
        display: inline-block;
        transform: rotate(0);
        transition: transform 1s;
    }

    .rate {
        line-height: 1;
        font-size: 11px;
        margin: 2px auto;

        @media(max-width: 500px) {
            font-size: 8px;
        }
    }

    &.start, &.end, &.middle, &.closed {
        .shading {
            background-color: rgba(128, 128, 128, 0.4);
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }

    &.middle .day-number {
        text-decoration: line-through;
    }

    &.start .shading {
        clip-path: polygon(3% 100%, 100% 3%, 100% 100%);
    }

    &.end .shading {
        clip-path: polygon(0% 0%, 0% 97%, 97% 0%);
    }

    &.start.end .shading, &.start.closed .shading, &.end.closed .shading, &.middle .shading {
        clip-path: unset;
    }

    //.start.shown, .middle.shown, .end.shown {
    //    opacity: 0.5;
    //}
    .may-click {
        clip-path: circle(25% at 50% 50%);
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .mode-check-in &.may-check-in, .mode-check-out &.may-check-out, .mode-selected &.may-check-in {
        cursor: pointer;

        .may-click {
            background-color: rgba(157, 166, 114, 0.3);
        }

        &:hover {
            .day-number {
                transform: rotate(360deg);
            }

            .may-click {
                background-color: rgba(157, 166, 114, 0.5);
            }
        }
    }

    &.selected-check-in, &.selected-check-out {
        .day-number {
            font-weight: bold;
        }

        .may-click {
            background-color: rgba(157, 166, 114, 1);
        }
    }

    &.selected {
        background-color: rgba(157, 166, 114, 0.4);
    }
}
</style>